import { useId } from "react";
import { Trans, useTranslation } from "react-i18next";
import { SCFORH_INFO_URL } from "../constants/scforhClubHealth";
import { useBrand } from "../context/BrandContext";
import "./ScforhApproachIntro.css";

const DIMS = [
  { id: "physical", className: "scforh-intro__dim--physical" },
  { id: "mental", className: "scforh-intro__dim--mental" },
  { id: "social", className: "scforh-intro__dim--social" },
];

/**
 * Concise visual primer on the health-in-clubs approach, shown before
 * the Sports Club for Health name so the research lands first.
 */
export default function ScforhApproachIntro({
  variant = "full",
  tone = "auto",
  lng,
} = {}) {
  const { t, i18n } = useTranslation();
  const { themeMode } = useBrand();
  const headingId = useId();
  const translate = lng ? i18n.getFixedT(lng) : t;
  const isCompact = variant === "compact";
  const bodyKey = isCompact ? "scforhIntroBodyCompact" : "scforhIntroBody";
  const resolvedTone =
    tone === "auto" || tone == null
      ? themeMode === "dark"
        ? "dark"
        : "light"
      : tone;

  return (
    <section
      className={`scforh-intro scforh-intro--${variant} scforh-intro--${resolvedTone}`}
      aria-labelledby={headingId}
    >
      <p className="scforh-intro__eyebrow">{translate("scforhIntroEyebrow")}</p>
      <h3 id={headingId} className="scforh-intro__title">
        {translate("scforhIntroTitle")}
      </h3>
      <p className="scforh-intro__body">{translate(bodyKey)}</p>
      <p className="scforh-intro__tt">{translate("scforhIntroTtLongevity")}</p>
      <ul className="scforh-intro__dims">
        {DIMS.map((dim) => (
          <li key={dim.id} className={`scforh-intro__dim ${dim.className}`}>
            <span className="scforh-intro__dim-mark" aria-hidden="true" />
            <span>{translate(`scforhIntroDim_${dim.id}`)}</span>
          </li>
        ))}
      </ul>
      <p className="scforh-intro__name">
        <Trans t={translate} i18nKey="scforhIntroName" />
      </p>
      <p className="scforh-intro__research">{translate("scforhIntroResearch")}</p>
      <p className="scforh-intro__more">
        <Trans
          t={translate}
          i18nKey="scforhIntroMore"
          components={{
            link: (
              <a
                className="scforh-intro__more-link"
                href={SCFORH_INFO_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
              />
            ),
          }}
        />
      </p>
    </section>
  );
}
